import React from 'react'
import styled from 'styled-components'
import { asCurrency } from '@ally/aos-utils'
import { Box, TextBody, Space } from '@ally/metronome-ui'
import { useAccountTypes } from '../providers'
import TotalBalanceDejarg from '../CustomizeDashboard/Widgets/AccountsOverviewWidget/TotalBalanceDejarg'

const StyledTextBody = styled(TextBody)`
  ${({ theme }): string => {
    return `
    /* match the line-height of the Snapshot h1 for even alignment */
    line-height: ${theme.font.heading.lg.lineHeight};
    `
  }}
`

export const TotalBalance = (): JSX.Element => {
  const { totalBalanceOfBankAndInvest } = useAccountTypes()
  return (
    <Box display="flex" flexDirection="column" alignItems="flex-end">
      <StyledTextBody tag="p" size="xl" weight="bold">
        {asCurrency(totalBalanceOfBankAndInvest.toString())}
      </StyledTextBody>
      <Space mt="xs" mb="sm">
        <Box display="flex" alignItems="center">
          <TotalBalanceDejarg />
          <Box display="inline-block">
            <TextBody tag="p" size="sm">
              &nbsp;Total
            </TextBody>
          </Box>
        </Box>
      </Space>
    </Box>
  )
}
